import { api, apiFile, base_url_v1, base_url_v2 } from "./api";
import { convertStringDateToDate } from "../utils";

export const JobsGroupApi = async () => {
    const data = await api({ url: `${base_url_v2}company/job-groups`, method: "GET", token: true })
    return data;
}

export const SingleJobsGroupApi = async (id: any) => {
    const data = await api({ url: `${base_url_v2}company/job-groups/${id}`, method: "GET", token: true })
    return data;
}


export const AddJobsGroupApi = async (formRef: any) => {
    let postData = JSON.stringify({
        'name': formRef.current['name'].value,
        'description': formRef.current['description'].value,
        'status': +formRef.current['status'].checked ? 1 : 0,
    })
    const data = await api({ url: `${base_url_v2}company/job-groups`, method: "POST", token: true, body: postData })
    return data;
}

export const JobsGroupChangeStatusApi = async (status: any, name: string, id: number) => {
    let postData: any = {
        'id': id,
        'name': name,
        'status': status ? 1 : 0,
    }

    const data = await api({ url: `${base_url_v2}company/job-groups/${id}`, method: "PATCH", token: true, body: JSON.stringify(postData) })
    return data;
}

export const JobsGroupEditApi = async (formRef: any, singleData: any) => {
    let postData = JSON.stringify({
        'id': +singleData.id,
        'name': formRef.current['name'].value,
        'description': formRef.current['description'].value,
        'status': +formRef.current['status'].checked ? 1 : 0,
    })

    const data = await api({ url: `${base_url_v2}company/job-groups/${singleData.id}`, method: "PATCH", token: true, body: postData })
    return data;
}

export const DeleteJobsGroupApi = async (id: any) => {
    const data = await api({ url: `${base_url_v2}company/job-groups/${id}`, method: "DELETE", token: true })
    return data;
}



// ################  Jobs Api ##########

export const JobsApi = async () => {
    const data = await api({ url: `${base_url_v2}company/jobs`, method: "GET", token: true })
    return data;
}

export const SingleJobsApi = async (id: any) => {
    const data = await api({ url: `${base_url_v2}company/jobs/${id}`, method: "GET", token: true })
    return data;
}


export const AddJobsApi = async (formRef: any) => {
    let postData = JSON.stringify({
        'name': formRef.current['name'].value,
        'description': formRef.current['description'].value,
        'job_group_id': +formRef.current['group'].value,
        'status': +formRef.current['status'].checked ? 1 : 0,
    })
    const data = await api({ url: `${base_url_v2}company/jobs`, method: "POST", token: true, body: postData })
    return data;
}

export const JobsChangeStatusApi = async (status: any, name: string, id: number) => {
    let postData: any = {
        'id': id,
        'name': name,
        'status': status ? 1 : 0,
    }

    const data = await api({ url: `${base_url_v2}company/jobs/${id}`, method: "PATCH", token: true, body: JSON.stringify(postData) })
    return data;
}

export const JobsEditApi = async (formRef: any, singleData: any) => {
    let postData = JSON.stringify({
        'id': +singleData.id,
        'name': formRef.current['name'].value,
        'description': formRef.current['description'].value,
        'job_group_id': +formRef.current['group'].value,
        'status': +formRef.current['status'].checked ? 1 : 0,
    })

    const data = await api({ url: `${base_url_v2}company/jobs/${singleData.id}`, method: "PATCH", token: true, body: postData })
    return data;
}

export const DeleteJobsApi = async (id: any) => {
    const data = await api({ url: `${base_url_v2}company/jobs/${id}`, method: "DELETE", token: true })
    return data;
}



// ################  Operation Api ##########

export const OperationApi = async () => {
    const data = await api({ url: `${base_url_v2}company/settings`, method: "GET", token: true })
    return data;
}

export const SingleOperationApi = async (id: any) => {
    const data = await api({ url: `${base_url_v2}company/settings/${id}`, method: "GET", token: true })
    return data;
}


export const AddOperationApi = async (formRef: any) => {
    let duration, unit;
    if (formRef.current['period'].value == 1) { duration = "5"; unit = "minute" }
    if (formRef.current['period'].value == 2) { duration = "30"; unit = "minute" }
    if (formRef.current['period'].value == 3) { duration = "1"; unit = "hour" }
    if (formRef.current['period'].value == 4) { duration = "8"; unit = "hour" }
    if (formRef.current['period'].value == 5) { duration = "1"; unit = "day" }
    if (formRef.current['period'].value == 6) { duration = "7"; unit = "day" }
    if (formRef.current['period'].value == 7) { duration = "15"; unit = "day" }
    if (formRef.current['period'].value == 8) { duration = "30"; unit = "day" }
    let postData = JSON.stringify({
        'action': formRef.current['action'].value,
        'category': +formRef.current['category'].value,
        'duration': duration,
        'unit': unit,
    })
    const data = await api({ url: `${base_url_v2}company/settings`, method: "POST", token: true, body: postData })
    return data;
}

export const OperationEditApi = async (formRef: any, singleData: any) => {
    let duration, unit;
    if (formRef.current['period'].value == 1) { duration = "5"; unit = "minute" }
    if (formRef.current['period'].value == 2) { duration = "30"; unit = "minute" }
    if (formRef.current['period'].value == 3) { duration = "1"; unit = "hour" }
    if (formRef.current['period'].value == 4) { duration = "8"; unit = "hour" }
    if (formRef.current['period'].value == 5) { duration = "1"; unit = "day" }
    if (formRef.current['period'].value == 6) { duration = "7"; unit = "day" }
    if (formRef.current['period'].value == 7) { duration = "15"; unit = "day" }
    if (formRef.current['period'].value == 8) { duration = "30"; unit = "day" }
    let postData = JSON.stringify({
        'action': formRef.current['action'].value,
        'duration': duration,
        'unit': unit,
    })

    const data = await api({ url: `${base_url_v2}company/settings/${singleData.id}`, method: "PATCH", token: true, body: postData })
    return data;
}

export const DeleteOperationApi = async (id: any) => {
    const data = await api({ url: `${base_url_v2}company/settings/${id}`, method: "DELETE", token: true })
    return data;
}




// ################  VcationReasons Api ##########

export const VcationReasonsApi = async () => {
    const data = await api({ url: `${base_url_v2}company/vacation-reasons`, method: "GET", token: true })
    return data;
}

export const SingleVcationReasonsApi = async (id: any) => {
    const data = await api({ url: `${base_url_v2}company/vacation-reasons/${id}`, method: "GET", token: true })
    return data;
}


export const AddVcationReasonsApi = async (formRef: any) => {
    let postData = JSON.stringify({
        'title': formRef.current['reason'].value,
        'description': "",
    })
    const data = await api({ url: `${base_url_v2}company/vacation-reasons`, method: "POST", token: true, body: postData })
    return data;
}

export const VcationReasonsEditApi = async (formRef: any, singleData: any) => {
    let postData = JSON.stringify({
        'title': formRef.current['reason'].value,
        'description': "",
    })
    const data = await api({ url: `${base_url_v2}company/vacation-reasons/${singleData.id}`, method: "PATCH", token: true, body: postData })
    return data;
}

export const DeleteVcationReasonsApi = async (id: any) => {
    const data = await api({ url: `${base_url_v2}company/vacation-reasons/${id}`, method: "DELETE", token: true })
    return data;
}



// ################  DelayReasons Api ##########


export const DelayReasonsApi = async () => {
    const data = await api({ url: `${base_url_v2}company/reasons`, method: "GET", token: true })
    return data;
}

export const SingleDelayReasonsApi = async (id: any) => {
    const data = await api({ url: `${base_url_v2}company/reasons/${id}`, method: "GET", token: true })
    return data;
}


export const AddDelayReasonsApi = async (formRef: any) => {
    let postData = JSON.stringify({
        'description': formRef.current['description'].value,
    })
    const data = await api({ url: `${base_url_v2}company/reasons`, method: "POST", token: true, body: postData })
    return data;
}

export const DelayReasonsEditApi = async (formRef: any, singleData: any) => {
    let postData = JSON.stringify({
        'description': formRef.current['description'].value,
    })
    const data = await api({ url: `${base_url_v2}company/reasons/${singleData.id}`, method: "PATCH", token: true, body: postData })
    return data;
}

export const DeleteDelayReasonsApi = async (id: any) => {
    const data = await api({ url: `${base_url_v2}company/reasons/${id}`, method: "DELETE", token: true })
    return data;
}


// ################  holidays Api ##########


export const HolidaysApi = async (parms: any) => {
    let url_parms = '';
    for (let [key, value] of Object.entries(parms)) {
        if (key != 'user') {
            url_parms = `${url_parms}&${key}=${value}`
        }
        else if (key == 'user' && Array.isArray(value)) {
            for (let i of value) {
                url_parms = `${url_parms}&user_ids[]=${i}`
            }
        }
    }
    const data = await api({ url: `${base_url_v2}company/holidays?${url_parms}`, method: "GET", token: true })
    return data;
}

export const OfficialHolidaysApi = async () => {
    const data = await api({ url: `${base_url_v2}company/official-holidays`, method: "GET", token: true })
    return data;
}

export const SingleHolidaysApi = async (id: any) => {
    const data = await api({ url: `${base_url_v2}company/holidays/${id}`, method: "GET", token: true })
    return data;
}


export const AddHolidaysApi = async (formRef: any, singleDateRef: any) => {
    let postData = JSON.stringify({
        'title': formRef.current['title'].value,
        'description': formRef.current['description'].value,
        'date': convertStringDateToDate(singleDateRef.current.state.initialValue._d),
    })
    const data = await api({ url: `${base_url_v2}company/holidays`, method: "POST", token: true, body: postData })
    return data;
}

export const HolidaysEditApi = async (formRef: any, singleData: any, defualtDate: any) => {
    let postData = JSON.stringify({
        'title': formRef.current['title'].value,
        'description': formRef.current['description'].value,
        'date': `${defualtDate.start_date}`,
    })
    const data = await api({ url: `${base_url_v2}company/holidays/${singleData.id}`, method: "PATCH", token: true, body: postData })
    return data;
}

export const DeleteHolidaysApi = async (id: any) => {
    const data = await api({ url: `${base_url_v2}company/holidays/${id}`, method: "DELETE", token: true })
    return data;
}


// ################  schedules Api ##########


export const SchedulesApi = async () => {
    const data = await api({ url: `${base_url_v2}company/schedules`, method: "GET", token: true })
    return data;
}

export const SingleSchedulesApi = async (id:any) => {
    const data = await api({ url: `${base_url_v2}company/schedules/${id}`, method: "GET", token: true })
    return data;
}


export const DeleteSchedulesApi = async (id: any) => {
    const data = await api({ url: `${base_url_v2}company/schedules/${id}`, method: "DELETE", token: true })
    return data;
}



export const AddSchedulesApi = async (formRef: any, startDateRef: any, endDateRef: any, floatingTime: any) => {
    let postData: any = {}
    if (floatingTime) {
        postData = {
            'allowed_lateness_on_arrival':"" ,
            'allowed_lateness_on_exit':"",
            'allowed_rushing_on_arrival':"" ,
            "allowed_rushing_on_exit":"" ,
            'date': convertStringDateToDate(startDateRef.current.state.initialValue._d),
            'description':formRef.current['description'].value,
            'duration':+formRef.current['duration'].value,
            'except_holidays': formRef.current['except_holidays'].checked,
            'flexible': floatingTime,
            'job_group_id': +formRef.current['job-group'].value,
            'schedule_from': convertStringDateToDate(startDateRef.current.state.initialValue._d),
            'schedule_to': convertStringDateToDate(endDateRef.current.state.initialValue._d),
            'schedule_start_time':'00:00:00'
        }
    }
    else {
        let startMin = formRef.current['start_min'].value[0] == 0 ? formRef.current['start_min'].value[1] : formRef.current['start_min'].value
        let endMin = formRef.current['end_min'].value[0] == 0 ? formRef.current['end_min'].value[1] : formRef.current['end_min'].value
        let start = (+formRef.current['start_hours'].value * 60) + +startMin ;
        let end = (+formRef.current['end_hours'].value * 60) + +endMin ;
        postData = {
            'allowed_lateness_on_arrival':formRef.current['allowed_lateness_on_arrival'].value ,
            'allowed_lateness_on_exit':formRef.current['allowed_lateness_on_exit'].value,
            'allowed_rushing_on_arrival':formRef.current['allowed_rushing_on_arrival'].value ,
            "allowed_rushing_on_exit":formRef.current['allowed_rushing_on_exit'].value ,
            'date': convertStringDateToDate(startDateRef.current.state.initialValue._d),
            'description':formRef.current['description'].value,
            'duration':end - start ,
            'except_holidays': formRef.current['except_holidays'].checked,
            'flexible': floatingTime,
            'job_group_id': +formRef.current['job-group'].value,
            'repeat':{} ,
            'schedule_from': convertStringDateToDate(startDateRef.current.state.initialValue._d),
            'schedule_to': convertStringDateToDate(endDateRef.current.state.initialValue._d),
            'schedule_start_time':`${formRef.current['start_hours'].value}:${formRef.current['start_min'].value}:00`
        }
    }
    let repeat:any = {}
    if(formRef.current['sat'].checked) {repeat['6'] = true}
    if(formRef.current['sun'].checked) {repeat['0'] = true}
    if(formRef.current['mon'].checked) {repeat['1'] = true}
    if(formRef.current['tue'].checked) {repeat['2'] = true}
    if(formRef.current['wed'].checked) {repeat['3'] = true}
    if(formRef.current['thu'].checked) {repeat['4'] = true}
    if(formRef.current['fri'].checked) {repeat['5'] = true}
    postData['repeat'] = repeat ;
    const data = await api({ url: `${base_url_v2}company/schedules`, method: "POST", token: true, body: JSON.stringify(postData) })
    return data;
}


export const EditSchedulesApi = async (formRef: any , singleData:any) => {
    let postData: any = {}
    if (singleData.flexible == 1) {
        postData = {
            'allowed_lateness_on_arrival':0 ,
            'allowed_lateness_on_exit':0,
            'allowed_rushing_on_arrival':0 ,
            "allowed_rushing_on_exit":0 ,
            'description':formRef.current['description'].value,
            'duration':+formRef.current['duration'].value,
            'except_holidays': formRef.current['except_holidays'].checked ? 1 : 0,
            'flexible': true,
            'schedule_end_time':"00:00",
            'schedule_start_time':'00:00'
        }
    }
    else {
        postData = {
            'allowed_lateness_on_arrival':+formRef.current['allowed_lateness_on_arrival'].value ,
            'allowed_lateness_on_exit':+formRef.current['allowed_lateness_on_exit'].value,
            'allowed_rushing_on_arrival':+formRef.current['allowed_rushing_on_arrival'].value ,
            "allowed_rushing_on_exit":+formRef.current['allowed_rushing_on_exit'].value ,
            'description':formRef.current['description'].value,
            'except_holidays': formRef.current['except_holidays'].checked ? 1 : 0,
            'flexible': false,
            'repeat':{} ,
            'schedule_end_time':`${formRef.current['end_hours'].value}:${formRef.current['end_min'].value}`,
            'schedule_start_time':`${formRef.current['start_hours'].value}:${formRef.current['start_min'].value}`
        }
    }
    let repeat:any = {}
    if(formRef.current['sat'].checked) {repeat['6'] = true}
    if(formRef.current['sun'].checked) {repeat['0'] = true}
    if(formRef.current['mon'].checked) {repeat['1'] = true}
    if(formRef.current['tue'].checked) {repeat['2'] = true}
    if(formRef.current['wed'].checked) {repeat['3'] = true}
    if(formRef.current['thu'].checked) {repeat['4'] = true}
    if(formRef.current['fri'].checked) {repeat['5'] = true}
    postData['repeat'] = repeat ;
    const data = await api({ url: `${base_url_v2}company/schedules/${singleData.id}`, method: "PUT", token: true, body: JSON.stringify(postData) })
    return data;
}




